module.exports = __webpack_public_path__ + "static/media/icon-globalExp.857341fd.svg";